import { addresses } from "./constants";
import callIcon from "assets/svg/call-calling.svg";

const ContactInfo = () => {
  return (
    <div className="grid gap-6 font-SatoshiRegular text-bblack-1">
      {addresses.map((address) => {
        const { id, name, location, icon } = address;
        return (
          <div
            key={id}
            className="flex gap-6 items-center bg-white p-4 rounded-xl"
          >
            <div>
              <img src={icon} alt="Location Icon" className="" />
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-bblack-6">{name}</span>
              <span className="font-Medium leading-6 text-lg text-bblack-5">
                {location}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default ContactInfo;
